import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './root';

ReactDOM.render(<Root />, document.getElementById('app'));


// WEBPACK FOOTER //
// ./src/index.js